import {InjectionToken, ModuleWithProviders, NgModule, Provider} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ValidationService} from './services/validation.service';
import {CommonModule} from '@angular/common';
import {AllowedValueValidatorDirective} from './directives/validators/allowed-value-validator.directive';
import {ExternalValidatorDirective} from './directives/validators/external-validator.directive';
import {ValidationNamedFormContextDirective} from './directives/context/validation-named-form-context.directive';
import {ValidationModelDirective} from './directives/item/validation-model.directive';
import {ValidationCheckSubmitDirective} from './directives/check/validation-check-submit.directive';
import {MaxValidatorDirective} from './directives/validators/max-validator.directive';
import {ValidationGroupDirective} from './directives/item/validation-group.directive';
import {ValidationNamedContextDirective} from './directives/context/validation-named-context.directive';
import {VALIDATION_SKIP_DEFAULT_RULES} from './directives/item/validation-item-base.directive';
import {ValidationSemanticContextDirective} from './directives/context/validation-semantic-context.directive';
import {MinValidatorDirective} from './directives/validators/min-validator.directive';
import {ValidationCommonContextDirective} from './directives/context/validation-common-context.directive';
import {ValidationCheckContinueDirective} from './directives/check/validation-check-continue.directive';
import {RequiredValidatorDirective} from './directives/validators/required-validator.directive';
import {FormDisabledDirective} from './directives/utils/form-disabled.directive';
import {ModelGroupDisabledDirective} from './directives/utils/model-group-disabled.directive';
import {IValidationConfiguration, VALIDATION_CONFIGURATION} from './types';

const VALIDATION_DECLARATIONS = [
    // Check directives
    ValidationCheckSubmitDirective,
    ValidationCheckContinueDirective,

    // Context directives
    ValidationCommonContextDirective,
    ValidationNamedContextDirective,
    ValidationNamedFormContextDirective,
    ValidationSemanticContextDirective,
    // Validators directives.
    AllowedValueValidatorDirective,
    ExternalValidatorDirective,
    MinValidatorDirective,
    MaxValidatorDirective,
    RequiredValidatorDirective,
    // Validation item
    ValidationModelDirective,
    ValidationGroupDirective,
    // Utils
    FormDisabledDirective,
    ModelGroupDisabledDirective,
];

export function provideValidationWithRules(
    $config: IValidationConfiguration | InjectionToken<IValidationConfiguration>,
    $skipRules?: Array<string>
): Array<Provider> {
    const validationConfiguration = {
        provide: VALIDATION_CONFIGURATION,
        multi: true,
        useValue: $config
    };

    if ($skipRules) {
        return [
            validationConfiguration,
            {
                provide: VALIDATION_SKIP_DEFAULT_RULES,
                useValue: $skipRules,
            },
            ValidationService,
        ];
    }

    return [
        validationConfiguration,
        ValidationService,
    ];
}

@NgModule({
    imports: [
        CommonModule,
        // Not sure if this is required.
        FormsModule,
    ],
    providers: [
        ValidationService,
        {
            provide: VALIDATION_SKIP_DEFAULT_RULES,
            useValue: []
        }
    ],
    declarations: VALIDATION_DECLARATIONS,
    exports: VALIDATION_DECLARATIONS
})
export class ValidationModule {
    static withRules($config: IValidationConfiguration | InjectionToken<IValidationConfiguration>, $skipRules?: Array<string>): ModuleWithProviders<ValidationModule> {
        return {
            ngModule: ValidationModule,
            providers: provideValidationWithRules($config, $skipRules),
        };
    }
}
